import React from 'react';
import { Panel, ProductCardPreview, Spinner } from 'dab-component-lib';
import { graphql, compose } from 'react-apollo';
import { currentUserCart, currencyById, currentUserQuery } from '../../../queries';
import _ from 'lodash';
import I18n from '../../../I18n/I18n';
import { AbsoluteContainerStyle, CartPanelWrapper, EmptyDescription, EmptyTitle } from './style';
import { LoadingStyle } from '../../../utils/style-utils';

class CartMenu extends React.Component {

  render() {
    const {onCheckout, currentUserCart: {loading, error, currentusercartGraphql1View}, currencyById, onClose, currentUserQuery} = this.props;

    return (
      <AbsoluteContainerStyle>
        <CartPanelWrapper>
          <Panel
            action={!loading && !error && currentusercartGraphql1View.results.length > 0 && currentusercartGraphql1View.results[0].fieldLineItemsReference.length > 0 ? {
                label: I18n.t('buttons.goCheckout'),
                onClick: onCheckout
              } : null}

            size="L"
            skin="secondary"
            title={I18n.t('menu.cart')}
            onClose={onClose}
          >
            {
              (!loading && !error && !currencyById.error && !currencyById.loading && !currentUserQuery.loading && !currentUserQuery.error) ?
              <div>
                {currentusercartGraphql1View.results.length > 0 && currentusercartGraphql1View.results[0].fieldLineItemsReference.length > 0 ?
                  currentusercartGraphql1View.results[0].fieldLineItemsReference.map(item => {
                    let product = item.entity.fieldProductReference.entity;
                    let quantity = item.entity.fieldProductReference.quantity;
                    let currencySign = null;
                    let price = {};
                    if (!currencyById.error && !currencyById.loading) {
                      let currencyName = currencyById.nodeById.fieldCurrencyName;
                      currencySign = currencyById.nodeById.fieldCurrencySign;
                      price = _.find(product.fieldPrices, price => price.entity.fieldCurrency === (currencyName ? currencyName : "EUR"))
                    }
                    return (
                      <div key={item.targetId}>
                        <ProductCardPreview
                          currency={currencySign}
                          handleGoToDetail={function () {
                        }}
                          id={product.fieldCode}
                          lang={localStorage.getItem('language') ? localStorage.getItem('language') : "it"}
                          name={product.name}
                          photoUrl={product.fieldProductImages.length > 0 ? product.fieldProductImages[0].url : ""}
                          price={parseFloat(price.entity.fieldPriceAmount * quantity).toFixed(2)}
                          quantity={quantity}
                          showPrice={localStorage.getItem('showPrices') === 'true' && !_.find(currentUserQuery.currentUserContext.roles, role => role.targetId === 'visitor_customer')}
                          size={item.entity.fieldSizeName}
                        />
                      </div>
                    )
                  })
                  :
                  <div>
                    <EmptyTitle>{I18n.t('menu.emptyCart')}</EmptyTitle>
                    <EmptyDescription>
                      {I18n.t('menu.emptyCartDesc')}
                    </EmptyDescription>
                  </div>
                }
              </div>
            :
                <LoadingStyle small>
                  <Spinner size={100} />
                </LoadingStyle>
            }
          </Panel>
        </CartPanelWrapper>
      </AbsoluteContainerStyle>
    );
  };
}

export default compose(
  graphql(currentUserQuery, {
    name: 'currentUserQuery'
  }),
  graphql(currentUserCart, {
    name: 'currentUserCart',
    options: props => ({
      variables: {
        id: localStorage.getItem('currentUid'),
        lang: localStorage.getItem('language') ? localStorage.getItem('language') : "it"
      }
    })
  }),
  graphql(currencyById, {
    name: 'currencyById',
    options: props => ({
      variables: {
        id: localStorage.getItem('currency') ? localStorage.getItem('currency') : localStorage.getItem('defaultCurrency')
      }
    })
  })
)(CartMenu);


// WEBPACK FOOTER //
// ./src/components/common/cartMenu/index.js